/**
 * Final Dividends — 폼값(snake_case) → 템플릿 [[변수]](PascalCase) 최종 변환.
 *   · 원본 docx 토큰이 PascalCase([[Company_Name]] 등)라, cdd 의 snake_case 값을 PascalCase 키로 alias 한다.
 *   · shareholders(주주×금액) 반복 배열, Signers/Signing_Director_Signature 서명 배열은 그대로 통과.
 *   · 날짜는 ISO(YYYY-MM-DD) 유지 — 백엔드 치환기가 세션 형식으로 변환.
 *   백엔드 loop 는 토큰 대소문자/구분자를 정규화하므로 배열 요소 키는 snake 든 Pascal 이든 채워진다.
 */

/** snake_case cdd 키 → PascalCase 템플릿 토큰. */
const TOKEN_MAP: Record<string, string> = {
  company_name: 'Company_Name',
  company_registration_no: 'Company_Registration_No',
  registered_office_address: 'Registered_Office_Address',
  dividend_amount: 'Dividend_Amount',
  total_dividend_amount: 'Total_Dividend_Amount',
  financial_year_end: 'Financial_Year_End',
  member_name: 'Member_Name',
  member_address: 'Member_Address',
  number_of_shares: 'Number_Of_Shares',
  amount_to_receive: 'Amount_To_Receive',
  dividend_number: 'Dividend_Number',
  payment_date: 'Payment_Date',
  meeting_venue: 'Meeting_Venue',
  meeting_date: 'Meeting_Date',
  meeting_time: 'Meeting_Time',
  chairman_name: 'Chairman_Name',
  resolution_date: 'Resolution_Date',
  notice_date: 'Notice_Date',
  letter_date: 'Letter_Date',
  resolution_passed_date: 'Resolution_Passed_Date',
  csp_email: 'CSP_Email',
  corporate_representative_name: 'Corporate_Representative_Name',
  holding_company_name: 'Holding_Company_Name',
};

/** 배열/객체(서명·반복부)로 취급해 문자열화하지 않는 키. */
const PASSTHROUGH_ARRAY_KEYS = new Set([
  'shareholders', 'Signers', 'signers', 'Signing_Director_Signature',
]);

export function normalizeFinalDividendsForWord(input: Record<string, any>): Record<string, any> {
  const out: Record<string, any> = { ...input };

  for (const [snake, pascal] of Object.entries(TOKEN_MAP)) {
    const v = input[snake];
    if (v === undefined || v === null) continue;
    if (PASSTHROUGH_ARRAY_KEYS.has(snake)) continue;
    // 이미 PascalCase 값이 명시돼 있으면(패널이 직접 세팅) 덮지 않는다.
    if (out[pascal] === undefined || String(out[pascal] ?? '').trim() === '') {
      out[pascal] = typeof v === 'string' ? v : v;
    }
  }

  return out;
}
